import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IntegrationService } from '../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'number-filter-component',
    template: `<input
        #eInput
        class="ag-text-field-input"
        type="text"
        [(ngModel)]="currentValue"
        (click)="openMenu()"
        [ngClass]="currentValue ? 'input-background-active' : ''" />
        @if (!currentValue) {
          <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
        }
        @if (currentValue) {
          <span class="sdps-text-secondary delete-icon-padding" (click)="clearNumField($event)"
            ><img class="deleteIcon" [src]="deleteIcon"
          /></span>
        }`,
    styleUrls: ['./number-floating-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, NgClass]
})
export class NumberFloatingFilterComponent implements OnInit, AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef, static: true }) eInput: ElementRef;
  params: IFloatingFilterParams;
  currentValue: Number | null | string = null;
  public deleteIcon: string;

  constructor(private integrationService: IntegrationService) {}

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }
  agInit(params: IFloatingFilterParams): void {
    this.params = params;
    if (params.column.getColId() === 'amount') {
      this.eInput.nativeElement.style.flexDirection = 'row-reverse';
    }
  }

  openMenu(): void {
    this.params.api.showColumnFilter(this.params.column.getColId());
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      if (parentModel.type && parentModel.type === 'inRange') {
        this.currentValue = parentModel.filter + ' - ' + parentModel.filterTo;
      } else {
        this.currentValue = parentModel.filter;
      }
    }
  }
  clearNumField(event): void {
    event.preventDefault();
    this.currentValue = null;
    const colID = this.params.column.getColId();
    this.params.api.setColumnFilterModel(colID, null);
    this.params.api.onFilterChanged();
  }
}
